import React, { PropTypes } from 'react';
import PromotionEditForm from '../PromotionEditForm';
import LoadingSpinner from '../../LoadingSpinner';

class PromotionNew extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let { loading, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <PromotionEditForm label="Create Promotion" {...rest}/>
      </LoadingSpinner>
    );
  }
}

export default PromotionNew;



// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionNew/PromotionNew.jsx